import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 5644CD16-FA4D-4F68-8DAC-996169C778E1
 * name cross
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cross.svg
 * tags
 * - Religion 
 * - Holiday 
 */
export const CrossIcon = createSvgIcon(<><path d="M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z" /></>, 'CrossIcon');
export default CrossIcon